import http from './httpClient';

const DocumentationMS = {
  getChildrenPages(pageId: string) {
    return http.get(
      `${import.meta.env.VITE_DOCUMENTATION_V0_BASE}/confluence/content/pages/${pageId}/children`
    );
  },

  getPageContent(pageTitle: string) {
    return http.get(
      `${import.meta.env.VITE_DOCUMENTATION_V0_BASE}/confluence/content/pages/${pageTitle}`
    );
  },

  getWhatsNew(lang?: string) {
    const langSegment = lang === 'de' ? '/de' : '/en';
    return http.get(`${import.meta.env.VITE_DOCUMENTATION_V0_BASE}/gitlab${langSegment}/whats-new`);
  },

  getGitlabWikiPage(slug: string, lang?: string) {
    const params = new URLSearchParams({ slug: `${lang === 'de' ? 'de/' : ''}${slug}` });
    return http.get(
      `${import.meta.env.VITE_DOCUMENTATION_V0_BASE}/gitlab/wiki-page?${params.toString()}`,
      { skipAuth: true }
    );
  },
};

export default DocumentationMS;
